import { type UploadFileWithPreviewFormDataFragment } from '../../../../api/fragments';
import {
    type GiftVoucherModuleEmailContentInput,
    type GiftVoucherModuleEmailContentCustomerInput,
    type GiftVoucherModuleEmailContentSalesPersonInput,
} from '../../../../api/types';

export enum HeaderTabs {
    MainDetails = 'mainDetails',
    Email = 'email',
}

type EmailContentWithIntroImage = GiftVoucherModuleEmailContentInput & {
    introImage?: File | UploadFileWithPreviewFormDataFragment;
};

export type GiftVoucherEmailFormValues = {
    customer: {
        [key in keyof GiftVoucherModuleEmailContentCustomerInput]: EmailContentWithIntroImage;
    };
    salesPerson?: {
        [key in keyof GiftVoucherModuleEmailContentSalesPersonInput]: EmailContentWithIntroImage;
    };
};
